import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Scholarship = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.185 10.749v.923c-2.196.337-3.88 2-3.88 4.01 0 2.694 2.075 3.455 3.88 3.89v4.987c-1.294-.282-2.25-1.228-2.25-2.347a.821.821 0 0 0-.815-.815.821.821 0 0 0-.816.815c0 2.01 1.685 3.673 3.88 4.01v.923c0 .446.37.815.816.815.446 0 .815-.37.815-.815v-.923c2.196-.337 3.88-2 3.88-4.01 0-2.716-2.075-3.488-3.88-3.922v-4.944c1.196.282 2.25 1.14 2.25 2.336 0 .445.37.815.815.815.446 0 .816-.37.816-.815 0-2.217-1.892-3.684-3.88-4.01v-.923A.821.821 0 0 0 22 9.934a.821.821 0 0 0-.815.815Zm-2.25 4.933c0-1.12.956-2.065 2.25-2.347v4.552c-1.544-.423-2.25-.901-2.25-2.205Zm6.13 6.53c0 1.12-.956 2.065-2.25 2.347v-4.585c1.544.424 2.25.923 2.25 2.238Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22.456 3.914a.821.821 0 0 0-.912 0L.359 18.279a.802.802 0 0 0-.359.673c0 .272.13.522.359.674l8.924 6.052v6.77c0 1.39.684 2.695 1.847 3.477l4.86 3.292A10.702 10.702 0 0 0 22 41.075c2.087 0 4.185-.619 6.01-1.858l4.86-3.292a4.21 4.21 0 0 0 1.847-3.477v-6.77l8.924-6.052a.802.802 0 0 0 .359-.674.802.802 0 0 0-.359-.673L22.457 3.914Zm9.5 30.664-4.858 3.292a9.047 9.047 0 0 1-10.196 0l-4.859-3.292a2.566 2.566 0 0 1-1.13-2.13v-5.661l10.63 7.204a.781.781 0 0 0 .457.141.781.781 0 0 0 .456-.141l10.631-7.204v5.66c0 .86-.424 1.652-1.13 2.13Zm1.49-10.008L22 32.328 2.272 18.952 22 5.566l19.728 13.376-8.282 5.628Z"
  }));
});
Scholarship.displayName = 'Scholarship';
Scholarship.defaultProps = {
  'aria-label': 'Scholarship'
};
export default Scholarship;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Scholarship.js
// module id = 3901
// module chunks = 11